import { brandConfig } from "@/config/brand";

export const BRAND_UI = {
  brand: {
    name: brandConfig.name,
    siteTitle: brandConfig.siteTitle,
  },
  auth: {
    loginHeader: brandConfig.auth.loginHeader,
    footer: brandConfig.auth.footer,
  },
  member: {
    creditsPage: {
      headerBackgroundImage: brandConfig.member.creditsPage.headerBackgroundImage,
    },
  },
  booking: {
    timeSlot: brandConfig.booking.timeSlot,
  },
  filter: {
    activeBorder: brandConfig.palette.filterActiveBorder,
    inactiveBorder: brandConfig.palette.filterInactiveBorder,
    trainerActiveBorder: brandConfig.palette.trainerFilterActiveBorder,
    trainerInactiveBorder: brandConfig.palette.trainerFilterInactiveBorder,
  },
};
